import { create } from "zustand";
import { GlobalSettingsResponse } from "../../api-client";

interface GlobalSettingsInterface {
  globalSettings: GlobalSettingsResponse | undefined;
  setGlobalSettings: (value: GlobalSettingsResponse | undefined) => void;
  getFlagValue: (flagName: string) => string | null;
}

export const useGlobalSettingsStore = create<GlobalSettingsInterface>(
  (set, get) => ({
    globalSettings: undefined,
    setGlobalSettings: (value: GlobalSettingsResponse | undefined) =>
      set({ globalSettings: value }),
    getFlagValue: (flagName: string): string | null => {
      const globalSettings = get().globalSettings;
      if (!globalSettings || !globalSettings.flags) return null;
      const flag = globalSettings.flags.find((f) => f.name === flagName);
      return flag?.value || null;
    },
  })
);
